import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut } from "lucide-react";

const TABS = [
  { to: "/admin", label: "Weddings", end: true },
  { to: "/admin/reels", label: "Reels" },
  { to: "/admin/moodboards", label: "Moodboards" },
  { to: "/admin/stories", label: "Stories" },
  { to: "/admin/settings", label: "Site Settings" },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  if (user === undefined) return <div className="min-h-screen bg-[color:var(--bg)]" />;
  if (!user) {
    nav("/admin/login", { replace: true });
    return null;
  }

  return (
    <div className="min-h-screen bg-[color:var(--bg)] text-[color:var(--text)]">
      <header className="border-b border-[color:var(--border)] sticky top-0 z-30 bg-[color:var(--bg)]/95 backdrop-blur">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <Link to="/" className="font-display italic text-lg link-underline">Weddings by Mostash</Link>
            <span className="eyebrow text-[color:var(--text-muted)]">Admin</span>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-xs text-[color:var(--text-muted)] hidden md:inline">{user.email}</span>
            <button data-testid="admin-logout" onClick={logout} className="flex items-center gap-2 eyebrow link-underline">
              <LogOut size={12} /> Sign out
            </button>
          </div>
        </div>
        <nav className="max-w-[1400px] mx-auto px-5 md:px-10 flex gap-6 overflow-x-auto hide-scrollbar border-t border-[color:var(--border)]">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={`admin-tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `eyebrow py-4 border-b-2 whitespace-nowrap ${isActive ? "border-[color:var(--accent)] text-[color:var(--text)]" : "border-transparent text-[color:var(--text-muted)] hover:text-[color:var(--text)]"}`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-[1400px] mx-auto px-5 md:px-10 py-10">{children}</main>
    </div>
  );
}
